module.exports = {
	"library.footer.terms_of_use": "Όροι Χρήσης",
	"library.footer.terms_and_conditions": "Terms and Conditions",
	"library.footer.privacy_policy": "Πολιτική Απορρήτου",
	"library.footer.get_to_know_us": "Ποιοί Είμαστε",
	"library.footer.about": "Σχετικά",
	"library.footer.jobs": "Θέσεις Εργασίας",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Βοήθεια",
	"library.footer.find_events": "Βρείτε εκδηλώσεις",
	"library.footer.top_events": "Κορυφαίες εκδηλώσεις",
	"library.footer.host_events": "Εκδηλώσεις που φιλοξενούνται",
	"library.footer.become_a_host": "Φιλοξενείστε μια εκδήλωση",
	"library.footer.tour": "Τουρ",
	"library.footer.embeddable_widgets": "Ενσωματωμένα Γραφικά",
	"library.footer.customers": "Πελάτες",
	"library.footer.pricing": "Τιμολόγηση",
	"library.footer.get_the_onsite_app": "Κατεβάστε την εφαρμογή",
	"library.footer.developers": "Προγραμματιστές",
	"library.footer.contact_us": "Επικοινωνήστε μαζί μας"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/el.json
// module id = 1576
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16